require('./preGrantedCreditSidebar.scss');
require('./preGrantedCreditSidebar.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

//@utilities
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const { getMaskedAccount } = require('../../../../loansUtilities/loansHelper');

//@constant
const { WIZARD_FIRST_STEP } = require('constants/index');

class PreGrantedCreditSidebar extends React.Component {

    buildAmountItem() {
        const { immPreGrantedCredit } = this.props;
        const amount = immPreGrantedCredit.get('selectedAmount');

        const title = 'contractsView-amountRequested';
        const className = 'contract-pre-granted-credit-sidebar__list-item-important';
        let text = 'contractsView-toDefine';

        if (immPreGrantedCredit.get('firstEnterInStepTwo') && !!amount) {
            const formattedAmount = getFormattedString({
                amount,
                currency: immPreGrantedCredit.get('currency'),
                decimalsLength: decimalsLength(amount)
            });
            text = formattedAmount;
        }

        return (
            <OKInformativeListItem
                title={title}
                bodyText={text}
                className={className}
            />
        );
    }

    buildTin() {
        const tin = <FormattedText value="contractSummary-pregrantedTIN" />;
        return {
            text: tin,
            title: formatText('contractsView-tin')
        };
    }

    buildTae() {
        const { immPreGrantedCredit } = this.props;
        const visibleStep = immPreGrantedCredit.get('visibleStep');
        const tae = <FormattedText key="tae" value="contractSummary-pregrantedTAE" />;
        return {
            text: tae,
            title: formatText('contractsView-tae'),
            additionalLabel: visibleStep === 1 ? <sup>{2}</sup> : ""
        };
    }

    buildAssociatedAccountItem(selectedAccount) {
        const associatedAccountText = selectedAccount ? getMaskedAccount(selectedAccount) : "contractsView-toDefine";
        return (
            <OKInformativeListItem
                title="contractsView-associatedAccount"
                bodyText={associatedAccountText}
            />
        );
    }

    buildBalanceAssociatedText(selectedAccount) {
        let accountBalanceAssociatedText = "contractsView-toDefine";
        if (selectedAccount) {
            const realBalance = selectedAccount.getIn(['balances', 'realBalance']);
            accountBalanceAssociatedText = getFormattedString({
                amount: realBalance.get('amount'),
                currency: realBalance.get('currency'),
                decimalsLength: decimalsLength(realBalance.get('amount'))
            });
        }
        return accountBalanceAssociatedText;
    }

    buildBalanceAssociatedItem(selectedAccount) {
        const { immPreGrantedCredit } = this.props;
        const currenStep = immPreGrantedCredit.get('visibleStep');
        const className = selectedAccount ? 'contract-pre-granted-credit-sidebar__list-item-important' : '';
        let balanceAssociatedItem = null;
        if (currenStep !== WIZARD_FIRST_STEP) {
            balanceAssociatedItem = (
                <OKInformativeListItem
                    title="contractsView-accountBalanceAssociated"
                    bodyText={this.buildBalanceAssociatedText(selectedAccount)}
                    className={className}
                />
            );
        }
        return balanceAssociatedItem;
    }

    render() {
        const { immPreGrantedCredit, immAccounts } = this.props;
        const amountItem = this.buildAmountItem();
        const tin = this.buildTin();
        const tae = this.buildTae();

        const selectedAccount = immAccounts.getIn(['byId', immPreGrantedCredit.get('selectedAccount')], null);
        const associatedAccountItem = this.buildAssociatedAccountItem(selectedAccount);
        const accountBalanceAssociatedItem = this.buildBalanceAssociatedItem(selectedAccount);

        return (
            <OKSectionBox className="contract-pre-granted-credit-sidebar">
                <div className="contract-pre-granted-credit-sidebar__header">
                    <FormattedText value="contractLoanCompilationCard-summary" />
                </div>
                <div className="contract-pre-granted-credit-sidebar__list">
                    <OKInformativeList>
                        {amountItem}
                        <OKInformativeListItem
                            title={tin.title}
                            bodyText={tin.text}
                            className={"contract-pre-granted-credit-sidebar__list-item-font-weight"}
                        />
                        <OKInformativeListItem
                            title={tae.title}
                            isDarkTitle
                            bodyText={tae.text}
                            additionalLabel={tae.additionalLabel}
                        />
                        <div className="contract-pre-granted-credit-sidebar__separator" />
                        {associatedAccountItem}
                        {accountBalanceAssociatedItem}
                    </OKInformativeList>
                </div>
            </OKSectionBox>
        );
    }
}

PreGrantedCreditSidebar.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired
};

module.exports = PreGrantedCreditSidebar;
